export const SECTORS = [
  "Banking & Finance",
  "Information Technology",
  "FMCG",
  "Pharmaceuticals",
  "Automobiles",
  "Energy & Oil",
  "Infrastructure",
  "Metals & Mining",
  "Retail",
  "Telecom",
  "Real Estate",
  "Chemicals",
  "Healthcare",
  "Media & Entertainment",
  "Consumer Durables",
] as const;

export type Sector = (typeof SECTORS)[number];

export const EXCHANGES = ["NSE", "BSE", "NYSE", "NASDAQ", "ASX"] as const;

export const SCORE_LABELS: Record<number, string> = {
  1: "Poor",
  2: "Below Average",
  3: "Average",
  4: "Good",
  5: "Excellent",
};

export const FREE_REPORT_LIMIT = 3;

export const SUBSCRIPTION_PRICES = {
  PRO_MONTHLY: 999, // $9.99 in cents
  PRO_YEARLY: 9900, // $99.00 in cents
  PREMIUM_MONTHLY: 1999, // $19.99 in cents
  PREMIUM_YEARLY: 19900, // $199.00 in cents
} as const;
